export function isSidebarPathActive(
  pathname: string,
  targetPath: string,
): boolean {
  const current = pathname.replace(/\/+$/, "") || "/";
  const target = targetPath.replace(/\/+$/, "") || "/";

  if (target === "/") return current === "/";
  return current === target || current.startsWith(`${target}/`);
}
